import { request } from "@/utils/request";

 
export function GetItemById(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/Course/GetItemByIdFront",
    params,
  });
}
export function GetItemByIdL(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/Course/GetItemByIdFrontL",
    params,
  });
}
export function GetPage(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/Course/GetPageFront",
    params,
  });
} 

//下载
export function CourseAttachments(params = {}) {
  return request({
    method: "post",
    url: "/adminApi/Course/CourseAttachments",
    params,
  });
} 
 
export function GetCourseTimeSpanPageFront(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/CourseTimeSpan/GetPageFront",
    params,
  });
} 

export function GetCourseTimeSpanPageFrontExt(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/CourseTimeSpan/GetPageFrontExt",
    params,
  });
} 


export function AddViewLog(params = {}) {   
  return request({
    method: "get",
    url: "/adminApi/CourseViewLog/AddFront",
    params,
  });
}